"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("../components");
var Shortcuts_less_1 = __importDefault(require("./Shortcuts.less"));
var react_i18next_1 = require("react-i18next");
var Shortcuts = (0, react_1.forwardRef)(function (_, ref) {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(components_1.Section, { ref: ref, label: 'SETTINGS_NAV_SHORTCUTS' },
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_PLAY_PAUSE' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, t('SETTINGS_SHORTCUT_SPACE')))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_SEEK_FORWARD' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "\u2192"),
                react_1.default.createElement("div", { className: Shortcuts_less_1.default['label'] }, t('SETTINGS_SHORTCUT_OR')),
                react_1.default.createElement("kbd", null,
                    "\u21E7 ",
                    t('SETTINGS_SHORTCUT_SHIFT')),
                react_1.default.createElement("div", { className: Shortcuts_less_1.default['label'] }, "+"),
                react_1.default.createElement("kbd", null, "\u2192"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_SEEK_BACKWARD' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "\u2190"),
                react_1.default.createElement("div", { className: Shortcuts_less_1.default['label'] }, t('SETTINGS_SHORTCUT_OR')),
                react_1.default.createElement("kbd", null,
                    "\u21E7 ",
                    t('SETTINGS_SHORTCUT_SHIFT')),
                react_1.default.createElement("div", { className: Shortcuts_less_1.default['label'] }, "+"),
                react_1.default.createElement("kbd", null, "\u2190"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_VOLUME_UP' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "\u2191"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_VOLUME_DOWN' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "\u2193"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_MENU_SUBTITLES' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "S"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_MENU_AUDIO' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "A"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_MENU_INFO' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "I"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_MENU_VIDEOS' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "V"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_FULLSCREEN' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "F"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_SUBTITLES_DELAY' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "G"),
                react_1.default.createElement("div", { className: Shortcuts_less_1.default['label'] }, t('SETTINGS_SHORTCUT_AND')),
                react_1.default.createElement("kbd", null, "H"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_NAVIGATE_MENUS' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "1"),
                react_1.default.createElement("div", { className: Shortcuts_less_1.default['label'] }, t('SETTINGS_SHORTCUT_TO')),
                react_1.default.createElement("kbd", null, "6"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_GO_TO_SEARCH' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, "0"))),
        react_1.default.createElement(components_1.Option, { label: 'SETTINGS_SHORTCUT_EXIT_BACK' },
            react_1.default.createElement("div", { className: Shortcuts_less_1.default['shortcut-container'] },
                react_1.default.createElement("kbd", null, t('SETTINGS_SHORTCUT_ESC'))))));
});
exports.default = Shortcuts;
